import { ApiServiceBase, DEFAULT_API_OPTIONS } from "./apiServiceBase";

export class EasService extends ApiServiceBase {
  constructor({ baseUrl, timeout } = DEFAULT_API_OPTIONS) {
    super({ baseUrl, timeout });
    this._path = "eas";
  }

  bindingPowerLimit(corpId, ts, sign) {
    return this._axios.post(`${this._path}/powerlimitusers/${corpId}?ts=${ts}&sign=${sign}`);
  }
}

export const easService = new EasService();
